import React from 'react';
import Button, { type ButtonProps } from '@mui/material/Button';
import { useTranslation } from 'react-i18next';
import { getSmsPaymentsCreateUrl } from '../../auth/cascadeAuth';

type Props = Omit<ButtonProps<'a', { component: 'a' }>, 'href' | 'children' | 'component'>;

/**
 * Внешняя ссылка на пополнение баланса (SMS.BY по умолчанию); см. {@link getSmsPaymentsCreateUrl}.
 */
const SmsTopUpBalanceButton = React.forwardRef<HTMLAnchorElement, Props>(function SmsTopUpBalanceButton(
  props,
  ref
) {
  const { t } = useTranslation();
  return (
    <Button
      ref={ref}
      {...props}
      component="a"
      href={getSmsPaymentsCreateUrl()}
      target="_blank"
      rel="noopener noreferrer"
    >
      {t('common.topUpBalance')}
    </Button>
  );
});

export default SmsTopUpBalanceButton;
